/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { QnaMakerContextTreeNode } from 'src/qnaMaker/core/types/QnaMakerContextTreeNode';

export const flattenQnaContextualTree = (root: QnaMakerContextTreeNode, qnaId: number): QnaMakerContextTreeNode[] => {
    let flattenedTree: QnaMakerContextTreeNode[] = [];

    if (!root) {
        return flattenedTree;
    }

    flattenedTree.push(root);

    root.children.forEach(p => {
        flattenedTree = flattenedTree.concat(flattenQnaContextualTree(p, qnaId));
    });

    return flattenedTree;
};
